// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scoring-legend-content {
    width: 100%;
}

.legend-intro {
    font-size: 13px;
    color: #555;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #e0e0e0;
    line-height: 1.6;
}

.section-heading {
    font-size: 13px;
    font-weight: 700;
    color: #0066B2;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    margin-bottom: 10px;
    margin-top: 4px;
}

.section-divider {
    border-top: 1px solid #e0e0e0;
    margin: 18px 0;
}

.legend-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
}

.legend-table td {
    padding: 6px 10px;
    border-bottom: 1px solid #f0f0f0;
    vertical-align: middle;
    color: #333;
}

.legend-table tbody tr:last-child td {
    border-bottom: none;
}

.legend-label {
    font-weight: 700;
    color: #222;
    width: 160px;
    white-space: nowrap;
}

.outcome-badge {
    display: inline-block;
    font-weight: 700;
    padding: 2px 10px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
}

.outcome-badge.modernize      { background: #d4edda; color: #155724; }
.outcome-badge.already-modern { background: #cce5ff; color: #004085; }
.outcome-badge.excluded       { background: #f8d7da; color: #721c24; }
`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/assessments/scoring-legend-dialog/scoring-legend-dialog.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gCAAgC;IAChC,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA,gCAAgC,mBAAmB,EAAE,cAAc,EAAE;AACrE,gCAAgC,mBAAmB,EAAE,cAAc,EAAE;AACrE,gCAAgC,mBAAmB,EAAE,cAAc,EAAE","sourcesContent":[".scoring-legend-content {\n    width: 100%;\n}\n\n.legend-intro {\n    font-size: 13px;\n    color: #555;\n    margin-bottom: 16px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid #e0e0e0;\n    line-height: 1.6;\n}\n\n.section-heading {\n    font-size: 13px;\n    font-weight: 700;\n    color: #0066B2;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    margin-bottom: 10px;\n    margin-top: 4px;\n}\n\n.section-divider {\n    border-top: 1px solid #e0e0e0;\n    margin: 18px 0;\n}\n\n.legend-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 13px;\n}\n\n.legend-table td {\n    padding: 6px 10px;\n    border-bottom: 1px solid #f0f0f0;\n    vertical-align: middle;\n    color: #333;\n}\n\n.legend-table tbody tr:last-child td {\n    border-bottom: none;\n}\n\n.legend-label {\n    font-weight: 700;\n    color: #222;\n    width: 160px;\n    white-space: nowrap;\n}\n\n.outcome-badge {\n    display: inline-block;\n    font-weight: 700;\n    padding: 2px 10px;\n    border-radius: 4px;\n    font-size: 12px;\n    white-space: nowrap;\n}\n\n.outcome-badge.modernize      { background: #d4edda; color: #155724; }\n.outcome-badge.already-modern { background: #cce5ff; color: #004085; }\n.outcome-badge.excluded       { background: #f8d7da; color: #721c24; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
